import tinymce from "tinymce";
import "tinymce/themes/silver";
import "tinymce/models/dom";
import "tinymce/icons/default";
import "tinymce/skins/content/default/content";
import "tinymce/skins/ui/oxide/skin";
import "tinymce/skins/ui/oxide/content";
import "tinymce/plugins/image";
import "tinymce/plugins/link";
import "tinymce/plugins/lists/";
import "tinymce/plugins/table";
export default defineNuxtPlugin((nuxtApp) => {
	return {
		provide: {
			tinymce: tinymce,
		},
	};
});